import React, { useState, useEffect } from "react";


import InventoryUpdate from "./InventoryUpdate";
import ThemeSettings from '../commun/ThemeSettings';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import Footer from '../commun/Footer';
const InventoryUpdateForm = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateRange, setDateRange] = useState(false);
  const [selectedDays, setSelectedDays] = useState(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]); // Initially empty
  const [deluxeRoom, setDeluxeRoom] = useState(0);
  const [superDeluxeRoom, setSuperDeluxeRoom] = useState(0);
  const [showSave, setShowSave] = useState(false);


  // 👇 Check when both dates are selected
  useEffect(() => {
    if (fromDate && toDate) {
      setDateRange(true);
    } else {
      setDateRange(false);
    }
  }, [fromDate, toDate]);


  useEffect(() => {
    // Show "Save" button only when one of the room values is greater than zero
    setShowSave(deluxeRoom > 0 || superDeluxeRoom > 0);
  }, [deluxeRoom, superDeluxeRoom]);

  const handleDayToggle = (day) => {
    setSelectedDays((prevDays) =>
      prevDays.includes(day)
        ? prevDays.filter((d) => d !== day)
        : [...prevDays, day]
    );
  };


  return (
    <>
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />

          <div className="container">
            <div className="page-inner">
              <InventoryUpdate />
              <div className="col-12">
                <div className="p-1 shadow-sm rounded-2 mt-4 bg-white" >
                  <div className="bg-white p-4 rounded-md">
                    <div className="row g-3">
                      {/* Date Range Selection */}
                      <div className="col-12 col-md-6">
                        <label className="text-dark fw-semibold mb-2 d-block">
                          Select dates to update Inventory for *
                        </label>
                        <div className="d-flex flex-column flex-md-row gap-2">
                          <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                          />
                          <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                          />
                        </div>
                      </div>

                      {/* Day Selection */}
                      <div className="col-12 col-md-6">
                        <label className="fw-semibold text-dark mb-2 d-block">
                          Selected days ({selectedDays.length})
                        </label>
                        <div className="d-flex flex-wrap" style={{ maxWidth: "100%" }}>
                          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, index) => (
                            <button
                              key={index}
                              style={{
                                marginRight: "8px",
                                marginBottom: "6px",
                                padding: "7px 15px",
                                border: "1px solid",
                                borderRadius: "4px",
                                transition: "background-color 0.2s, color 0.2s",
                                backgroundColor: selectedDays.includes(day) ? "#27548A" : "#e2e2e2",
                                color: selectedDays.includes(day) ? "white" : "#333",
                                borderColor: selectedDays.includes(day) ? "#007bff" : "#ccc",
                                cursor: "pointer",
                              }}
                              onClick={() => handleDayToggle(day)}
                            >
                              {day}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>

                  {/* Inventory Form */}
                  {dateRange && (
                    <div className="p-4 mt-3 shadow rounded-2  bg-white">
                      <h5 className="fw-bold mb-3">Update Inventory</h5>
                      <hr />
                      <div className="row g-4">
                        <div className="col-12 col-md-6">
                          <label className="fw-semibold">Deluxe Room</label>
                          <input
                            type="number"
                            className="form-control rounded-1"
                            value={deluxeRoom}
                            onChange={(e) => setDeluxeRoom(Number(e.target.value))}
                            min={0}
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label className="fw-semibold">Super Deluxe Room</label>
                          <input
                            type="number"
                            className="form-control rounded-1"
                            value={superDeluxeRoom}
                            onChange={(e) => setSuperDeluxeRoom(Number(e.target.value))}
                            min={0}
                          />
                        </div>
                      </div>

                      {showSave && (
                        <div className="mt-4 text-end">
                          <hr />
                          <button className="btn btn-black">Save</button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              
            </div>
          </div>
          <Footer />
        </div>
        <ThemeSettings />
      </div>
    </>
  )
}

export default InventoryUpdateForm;
